import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import config from './config';

function SessionDetails() {
  const { sessionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [sessionDetails, setSessionDetails] = useState(null);
  const [clickedSession, setClickedSession] = useState(location.state?.session || null);

  useEffect(() => {
    const fetchSessionDetails = async () => {
      const response = await fetch(`${config.apiUrl}/api/v5/metrics/user-sessions/${sessionId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setSessionDetails(data.data); // Assuming the data is in the 'data' field
      } else {
        console.error('Failed to fetch session details');
      }
    };

    fetchSessionDetails();
  }, [sessionId]);

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  const handleBackClick = () => {
    navigate('/hello', {
      state: {
        activeTab: 1,
        metricsPage: location.state?.metricsPage || 1,
        metricsPageSize: location.state?.metricsPageSize || 20,
        sessionsPage: location.state?.sessionsPage || 1,
        sessionsPageSize: location.state?.sessionsPageSize || 20,
      },
    });
  };

  return (
    <div className="SessionDetails">
      <h1>Session Details</h1>
      <button onClick={handleBackClick}>Back to Session Metrics</button>
      {clickedSession && (
        <div className="session-metrics">
          <h2>Session Metrics</h2>
          <p><strong>ID:</strong> {clickedSession.id}</p>
          <p><strong>User ID:</strong> {clickedSession.user_id}</p>
          <p><strong>Email:</strong> {clickedSession.email}</p>
          <p><strong>Project ID:</strong> {clickedSession.project_id}</p>
          <p><strong>Event Time:</strong> {formatTimestamp(clickedSession.event_time)}</p>
          <p><strong>IP Address:</strong> {clickedSession.ip_address}</p>
          <p><strong>User Agent:</strong> {clickedSession.user_agent}</p>
          <p><strong>Client Version:</strong> {clickedSession.client_version}</p>
        </div>
      )}
      {sessionDetails ? (
        <table className="table">
          <thead>
            <tr>
              <th>Project Name</th>
              <th>Creator</th>
              <th>Workspace</th>
              <th>Event Time</th>
              <th>IP Address</th>
              <th>User Agent</th>
              <th>Client Version</th>
              <th>User ID</th>
              <th>Project ID</th>
            </tr>
          </thead>
          <tbody>
            {sessionDetails.map((session) => (
              <tr key={session.id}>
                <td>{session.project_name}</td>
                <td>{session.creator}</td>
                <td>{session.workspace}</td>
                <td>{formatTimestamp(session.event_time)}</td>
                <td>{session.ip_address}</td>
                <td>{session.user_agent}</td>
                <td>{session.client_version}</td>
                <td>{session.user_id}</td>
                <td>{session.project_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default SessionDetails;